import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: true,
  error: null,
  teamId: null,
  range: 'week',       // 'day' | 'week' | 'month'
  calls: [],
  members: [],
  selfExcluded: false,
};

export const analyticTeamDataSlice = createSlice({
  name: 'analyticTeamData',
  initialState,
  reducers: {
    setTeamAnalyticData: (state, action) => {
      const { teamId, range, calls = [], members = [], selfExcluded = false } = action.payload || {};
      state.loading = false;
      state.error = null;
      if (teamId != null) state.teamId = teamId;
      if (range) state.range = range;
      state.calls = calls;
      state.members = members;
      state.selfExcluded = selfExcluded;
    },
    resetTeamAnalyticData: () => initialState,
  },
});

export const { setTeamAnalyticData, resetTeamAnalyticData } = analyticTeamDataSlice.actions;

export const selectTeamAnalyticData = (state) => state.analyticTeamData;

export default analyticTeamDataSlice.reducer;
